<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    :overlay="false"
    min-width="500px"
  >
    <v-card>
      <v-toolbar dark color="#E3002C" class="d-flex align-center">
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text class="d-flex justify-space-around align-center">
          <h3>
            Items Seleccionados: {{ selected_items.length }}, Comisión Total
            USD: {{ getTotalCommission().toLocaleString("es-AR") }}
          </h3>
          <v-btn color="warning" outlined @click="onClose" class="mx-2">
            Cancelar
          </v-btn>
          <v-btn color="success" outlined @click="onSave" class="mx-2">
            Guardar
          </v-btn>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <paginated-search-table
            :endpoint="endpoint"
            :headers="headers"
            :searchLabel="searchLabel"
            :ordering="ordering"
            :filterString="filterString"
            :canEdit="canEdit"
            :canDelete="canDelete"
            :canAdd="canAdd"
            :searchOnURL="searchOnURL"
            :initialItemsPerPage="initialItemsPerPage"
            :multipleSelection="true"
            :selectedItems="selectedItems"
            @selectionChange="onSelectionChange($event)"
          ></paginated-search-table>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";

export default {
  name: "SaleCommissionSearchDialog",

  components: {
    PaginatedSearchTable
  },

  props: {
    title: {
      type: String,
      default: "Buscar..."
    },
    show: {
      type: Boolean,
      default: false
    },
    endpoint: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    searchLabel: {
      type: String,
      default: "Buscar"
    },
    ordering: {
      type: String,
      default: null
    },
    filterString: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    searchOnURL: {
      type: Boolean,
      default: false
    },
    initialItemsPerPage: {
      type: Number,
      default: 100
    },
    selectedItems: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  data() {
    return {
      selected_items: []
    };
  },

  methods: {
    onClose() {
      this.$emit("cancel");
    },

    onSelectionChange(items) {
      this.selected_items = items;
    },

    getTotalCommission() {
      const total_commission_usd = this.selected_items.reduce(
        (accumulator, object) => {
          return accumulator + parseFloat(object.claimable_usd);
        },
        0
      );
      return total_commission_usd;
    },

    onSave() {
      this.$emit("itemsSelected", this.selected_items);
    }
  },

  mounted() {
    this.selected_items = this.selectedItems;
  }
};
</script>
